import { render } from "./SaleList.vue?vue&type=template&id=07c29c22"
import script from "./SaleList.vue?vue&type=script&lang=js"
export * from "./SaleList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__